/**
 * Just a basic list of all translations that should be visible to Drupal!
 *
 * @todo Auto-generate file based when building react application.
 */
/* global Drupal */
// ## Customer info (fields)
// step_title
Drupal.t('Who is booking?', {}, { context: 'booking' });

// email
Drupal.t('Email', {}, { context: 'booking' });
Drupal.t(
  'We will send the booking confirmation to your email address.',
  {},
  { context: 'booking' }
);
Drupal.t('The email field is required', {}, { context: 'booking' });
Drupal.t('Your email is invalid', {}, { context: 'booking' });
Drupal.t('Email addresses do not match', {}, { context: 'booking' });

// verify_email
Drupal.t('Verify email', {}, { context: 'booking' });
Drupal.t('Re-enter your email address', {}, { context: 'booking' });
Drupal.t('Emails do not match', {}, { context: 'booking' });
Drupal.t('Your verification email is invalid', {}, { context: 'booking' });

// title
Drupal.t('Title', {}, { context: 'booking' });
Drupal.t('Mr.', {}, { context: 'booking' });
Drupal.t('Ms.', {}, { context: 'booking' });
Drupal.t('Mrs.', {}, { context: 'booking' });
Drupal.t('Miss.', {}, { context: 'booking' });
Drupal.t('The Title field is required', {}, { context: 'booking' });

// firstName
Drupal.t('First Name', {}, { context: 'booking' });
Drupal.t('Your first name is invalid', {}, { context: 'booking' });
Drupal.t('The first name field is required', {}, { context: 'booking' });

// lastName
Drupal.t('Last Name', {}, { context: 'booking' });
Drupal.t('Your last name is invalid', {}, { context: 'booking' });
Drupal.t('The last name field is required', {}, { context: 'booking' });

// streetNumber
Drupal.t('House number', {}, { context: 'booking' });
Drupal.t('Your house number is invalid', {}, { context: 'booking' });
Drupal.t('The house number field is required', {}, { context: 'booking' });

// flat
Drupal.t('Floor', {}, { context: 'booking' });
Drupal.t('Your floor is invalid', {}, { context: 'booking' });

// phone
Drupal.t('Phone Number', {}, { context: 'booking' });
Drupal.t('So we can contact you if there are any updates about your holiday.', {}, { context: 'booking' });
Drupal.t('Your phone number is invalid', {}, { context: 'booking' });
Drupal.t('The phone field is required', {}, { context: 'booking' });

// additionalPhone
Drupal.t('Alternative Phone Number', {}, { context: 'booking' });
Drupal.t(
  'Your alternative phone number is invalid',
  {},
  { context: 'booking' }
);
Drupal.t(
  'The alternative phone number field is required',
  {},
  { context: 'booking' }
);

// street
Drupal.t('Address', {}, { context: 'booking' });
Drupal.t('Your address is invalid', {}, { context: 'booking' });
Drupal.t('The address field is required', {}, { context: 'booking' });

// additional_address
Drupal.t('Additional Address field', {}, { context: 'booking' });
Drupal.t(
  'Your additional address field is invalid',
  {},
  { context: 'booking' }
);
Drupal.t(
  'The additional address field is required',
  {},
  { context: 'booking' }
);

// zipCode
Drupal.t('Postal code', {}, { context: 'booking' });
Drupal.t('Your postal code is invalid', {}, { context: 'booking' });
Drupal.t('The postal code field is required', {}, { context: 'booking' });

// city
Drupal.t('City', {}, { context: 'booking' });
Drupal.t('City is invalid', {}, { context: 'booking' });
Drupal.t('The city field is required', {}, { context: 'booking' });

// select_country
Drupal.t('Select Country', {}, { context: 'booking' });
Drupal.t('Your country selection is invalid', {}, { context: 'booking' });
Drupal.t('The country field is required', {}, { context: 'booking' });

// ## Booking Payment Section
Drupal.t('Payment', {}, { context: 'booking' });
Drupal.t('Pay the full amount now', {}, { context: 'booking' });
Drupal.t('Pay the amount in two installments', {}, { context: 'booking' });
Drupal.t(
  'Choose your payment method. You will pay in the next step.',
  {},
  { context: 'booking' }
);
Drupal.t('Payment method is invalid', {}, { context: 'booking' });
Drupal.t('Do you have a voucher code?', {}, { context: 'booking' });
Drupal.t('Voucher code', {}, { context: 'booking' });
Drupal.t('Redeem', {}, { context: 'booking' });
Drupal.t(
  'Please note that the discount is deducted from the rent price.',
  {},
  { context: 'booking' }
);
Drupal.t(
  'Discount codes and gift cards cannot be used with this payment method.',
  {},
  { context: 'booking' }
);
Drupal.t(
  'Discount codes and gift cards cannot be used with travel partner.',
  {},
  { context: 'booking' }
);

// ## Booking overview.
Drupal.t('My booking', {}, { context: 'booking' });
Drupal.t('Guests', {}, { context: 'booking' });
Drupal.t('Adult', {}, { context: 'booking' });
Drupal.t('Adults', {}, { context: 'booking' });
Drupal.t('Child', {}, { context: 'booking' });
Drupal.t('Children', {}, { context: 'booking' });
Drupal.t('(4-11 years)', {}, { context: 'booking' });
Drupal.t('(0-11 years)', {}, { context: 'booking' });
Drupal.t('Plus an additional child below 4 years.', {}, { context: 'booking' });
Drupal.t(
  'Plus I bring up to !children_count children below 4 years',
  {},
  { context: 'booking' }
);
Drupal.t(
  'In this holiday home you can bring a child (or children) FREE of charge. Please tick this box, if you would like to take advantage of the offer',
  {},
  { context: 'booking' }
);
Drupal.t('Pet', {}, { context: 'booking' });
Drupal.t('Pets', {}, { context: 'booking' });
Drupal.t('Persons', {}, { context: 'booking' });
Drupal.t('From', {}, { context: 'booking' });
Drupal.t('To', {}, { context: 'booking' });
Drupal.t('Rental', {}, { context: 'booking' });
Drupal.t('Security Package', {}, { context: 'booking' });
Drupal.t('Free', {}, { context: 'booking' });
Drupal.t('Tickets', {}, { context: 'booking' });
Drupal.t('Total price', {}, { context: 'booking' });
Drupal.t('Hide', {}, { context: 'booking' });

Drupal.t('Save', {}, { context: 'booking' });
Drupal.t('Check-in', {}, { context: 'booking' });
Drupal.t('Check-out', {}, { context: 'booking' });
Drupal.t('Change number of guests', {}, { context: 'booking' });
Drupal.t('Free cancellation', {}, { context: 'booking' });

// Normal terms
Drupal.t(
  'I confirm that the registered information is correct and that I have read and agree with the !astartrental terms!aend. Furthermore I confirm I am at least 18 years of age (for group bookings at least 21 years).',
  { '!astart': '<a href="/terms-and-conditions">', '!aend': '</a>' },
  { context: 'booking' }
);
// Request terms
Drupal.t(
  'I confirm that the registered information is correct and that I have read and agree with the !astartrental terms!aend. By confirming the booking, I am committed to pay the full amount if the booking is confirmed within 3 days. The request then automatically becomes a confirmed booking.',
  { '!astart': '<a href="/terms-and-conditions">', '!aend': '</a>' },
  { context: 'booking' }
);
// Agency Signon & Option terms - EC-858 - in regards to the "Option terms" text it will be updated by legal department
Drupal.t(
  'I confirm that the registered information is correct and that I have read and agree with the !astartrental and payment terms!aend. By confirming the booking, I agree to book the holiday for the customer and I am committed to paying the amount required.',
  { '!astart': '<a href="/terms-and-conditions">', '!aend': '</a>' },
  { context: 'booking' }
);

// Product terms
// LAND
Drupal.t(
  'I confirm that the registered information is correct and that I have read and agree with the !astartrental Landal terms!aend. Furthermore I confirm I am at least 18 years of age (for group bookings at least 21 years).',
  { '!astart': '<a href="/terms-and-conditions">', '!aend': '</a>' },
  { context: 'booking' }
);

Drupal.t('Book', {}, { context: 'booking' });
Drupal.t('Continue', {}, { context: 'booking' });
Drupal.t('Pay now', {}, { context: 'booking' });
Drupal.t('Pay for service now', {}, { context: 'booking' });
Drupal.t('Request booking now', {}, { context: 'booking' });
Drupal.t('Book now', {}, { context: 'booking' });
Drupal.t('Confirm', {}, { context: 'booking' });
Drupal.t('Pay before departure', {}, { context: 'booking' });
Drupal.t('Pay for service on arrival', {}, { context: 'booking' });
Drupal.t('Card fee', {}, { context: 'booking' });
Drupal.t('Discount', {}, { context: 'booking' });
Drupal.t('Apply voucher code', {}, { context: 'booking' });
Drupal.t('Close voucher code', {}, { context: 'booking' });
Drupal.t(
  'Since encrypted, your personal information is kept confidential.',
  {},
  { context: 'booking' }
);

// ## Booking pay rates
Drupal.t('Rates', {}, { context: 'booking' });
Drupal.t('Select payment method', {}, { context: 'booking' });
Drupal.t(
  'The 2. rate will be deducted automatically from you account on the due date.',
  {},
  { context: 'booking' }
);

// ## Extra service
Drupal.t('Attractions and Deals', {}, { context: 'booking' });
Drupal.t('Options', {}, { context: 'booking' });
Drupal.t('Mandatory', {}, { context: 'booking' });
Drupal.t('Optional', {}, { context: 'booking' });
Drupal.t(
  'Can be ordered after the booking has been confirmed and we have received your payment.',
  {},
  { context: 'booking' }
);
Drupal.t(
  'If you choose to clean the house yourself, please be aware that no or insufficient cleaning, as well as damages may lead to the payment of compensation',
  {},
  { context: 'booking' }
);
Drupal.t('Add', {}, { context: 'booking' });
Drupal.t('Remove', {}, { context: 'booking' });

// ## Tickets
Drupal.t('Show tickets', {}, { context: 'booking' });

// ## Price unit code text
Drupal.t('Daily price', {}, { context: 'booking' });
Drupal.t('Weekly price', {}, { context: 'booking' });
Drupal.t('Price per stay', {}, { context: 'booking' });
Drupal.t('Price per stay and unit', {}, { context: 'booking' });
Drupal.t('Price per person', {}, { context: 'booking' });
Drupal.t('Price per unit', {}, { context: 'booking' });
Drupal.t('Price per day and person', {}, { context: 'booking' });
Drupal.t('Price per week and person', {}, { context: 'booking' });

// ## Minimun price text
Drupal.t('Minimum price', {}, { context: 'booking' });

// #Travel Agency Options
Drupal.t('Travel Agency Options', {}, { context: 'booking' });
Drupal.t('Type of booking', {}, { context: 'booking' });
Drupal.t('booking', {}, { context: 'booking' });
Drupal.t('option', {}, { context: 'booking' });
Drupal.t('User ID', {}, { context: 'booking' });
Drupal.t('Message for !brand_name', {}, { context: 'booking' });

// #Travel Agency Select
Drupal.t('Choose your travel partner', {}, { context: 'booking' });
Drupal.t('Choose other travel partner', {}, { context: 'booking' });

// #Membership SubId
Drupal.t('Membership code', {}, { context: 'booking' });
Drupal.t('Travel agency / employee code', {}, { context: 'booking' });
Drupal.t('Agency sub id is invalid', {}, { context: 'booking' });

// RentalInformation
Drupal.t('Variable expenses', {}, { context: 'booking' });
Drupal.t(
  'Any variable costs listed in this section are paid in local currency at the destination',
  {},
  { context: 'booking' }
);
Drupal.t('Property ID', {}, { context: 'booking' });
Drupal.t('Additional information', {}, { context: 'booking' });
Drupal.t('incl.', {}, { context: 'booking' });

// Pager
Drupal.t('Previous', {}, { context: 'booking' });
Drupal.t('Next', {}, { context: 'booking' });

// Abandon basket.
Drupal.t('Email sent', {}, { context: 'booking' });
Drupal.t('We have sent the booking to', {}, { context: 'booking' });
Drupal.t('Finish your booking later', {}, { context: 'booking' });
Drupal.t(
  'Enter your email address below and we will send you your commenced booking - No spam, no sign-up needed',
  {},
  { context: 'booking' }
);
Drupal.t('Your email', {}, { context: 'booking' });
Drupal.t('Finish later', {}, { context: 'booking' });
Drupal.t(
  'Please send me a link by email so that I can complete my booking later',
  {},
  { context: 'booking' }
);
Drupal.t(
  'Please note that the e-mail will be sent to you shortly and it is not possible for you to change your mind once you have clicked “Finish Later”. We will not send you any further emails unless you are already subscribed to our newsletter. Any personal data you have already entered into the booking form will be deleted from NOVASOL’s system as soon as the email is sent to you and your email address will be deleted immediately.',
  {},
  { context: 'booking' }
);

// Final cleaning.
Drupal.t('No final cleaning', {}, { context: 'booking' });
Drupal.t(
  'Before your departure, you will handle the cleaning of the holiday home',
  {},
  { context: 'booking' }
);
Drupal.t('Click here for more information', {}, { context: 'booking' });
Drupal.t('Please select cleaning option', {}, { context: 'booking' });

// Status message.
Drupal.t('Booking unsuccessful', {}, { context: 'booking' });
Drupal.t('Payment was unsuccessful please try with a different payment method', {}, { context: 'booking' });
Drupal.t('No result found', {}, { context: 'booking' });

// Vouchers:
Drupal.t('The remaining !amount will be refunded after your payment has been processed on your new booking.', {}, { context: 'booking' });
Drupal.t('Your voucher code does not cover the full amount. You can book now and will be able to pay the remaining amount in your MyBooking after completing your booking.', {}, { context: 'booking' });
Drupal.t('!amount from the voucher has been adjusted against the payment of this booking.', {}, { context: 'booking' });

Drupal.t('A !productIcon holiday park home', {}, { context: 'booking' });

// Danish Properties
Drupal.t('Pay in MyBooking', {}, { context: 'booking' });
Drupal.t('Pay for service in MyBooking', {}, { context: 'booking' });
Drupal.t('Make payment now, or we will email you for payment one week before your holiday.', {}, { context: 'booking' });
